import { useSelector } from 'react-redux';
import { RootState } from '../reduxStore/Store';

export function usePermission(permissionCode: string): boolean {
  const permissions = useSelector((state: RootState) => state.AuthSlice.permissions);
  return permissions?.includes(permissionCode) ?? false;
}
